module.exports = __webpack_public_path__ + "static/assets/b6b6375a1dc4d81ac925afa1e521d9cb.png";